// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SupplierGroup = {};

SupplierGroup.getSupplerGroupItemSerch = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0; 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SupplierGroup/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SupplierGroup.getSupplerGroupItem = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SupplierGroup/Items?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SupplierGroup.getSupplerGroupApproval = function (userInput) {
  console.log("🚀 ~ userInputgetSupplerGroupApproval:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SupplierGroup/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SupplierGroup.addSupplierGroup = function (data) {
  console.log("🚀 ~ addSupplierGroupservic----e--ppp:", data);
  return lossClient({
    url: `/SupplierGroup/add`,
    method: "post",
    data: data,
  });
};
SupplierGroup.supplierGroupReturn = function (data) {
  return lossClient({
    url: `/SupplierGroup/return`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data,
  });
};

SupplierGroup.deleteSupplierGroup = function (data) {
  return lossClient({
    url: `/SupplierGroup/Delete`,
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: data,
  });
};

SupplierGroup.supplierGroupApproval = function (data) {
  return lossClient({
    url: `/SupplierGroup/Approve`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data,
  });
};

SupplierGroup.SupplerGroupRequest = function (data) {
  return lossClient({
    url: `/SupplierGroup/Request`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data,
  });
};
export default SupplierGroup;
